import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { forkJoin,of } from 'rxjs';

import {User,Store, User_Permission, Role, Storage, User_Storage } from '../../models/RestModels';
import {USER_PERMISSION_KEY} from 'src/app/services/rest.service';
import { GetEmpty } from 'src/app/classes/Empties';
import { Rest } from 'src/app/services/Rest';
import { UserStorageInfo } from 'src/app/models/models';


@Component({
	selector: 'app-save-user',
	templateUrl: './save-user.component.html',
	styleUrls: ['./save-user.component.css']
})

export class SaveUserComponent extends BaseComponent implements OnInit
{
	user:Partial<User>	= {};

	user_permission:User_Permission = GetEmpty.user_permission();
	store_list:Store[] = [];
	password_type:'text'|'password' = 'password';

	rest_role:Rest<Role,Role>= this.rest.initRest<Role,Role>('role');
    role_list: Role[] = [];

	user_storage_list: UserStorageInfo[] = [];
	all_storage_list: Storage[] = [];
	new_user_storage: User_Storage = { user_id: 0, storage_id: 0, sort_weight: 1 };

	administracion_permissions:string[] = [
		'add_user','add_asistance','add_roles','view_asistance','add_payroll','view_payroll',
		'add_form','view_responses','preferences','reports','add_commandas','currency_rates',
		'edit_billing_data','facturar_orden', 'factura_global', 'cancelar_factura',
		'cancel_payments', 'add_accounts','view_facturas'
	];

	shipping_permissions:string[] = [
		'send_shipping','global_send_shipping','receive_shipping','global_receive_shipping',
		'global_send_shipping'
	];

	requisition_permissions:string[] =[
		'add_requisition','global_requisition','approve_requisition','create_requisition_from_order', 'production','purchases',
		'global_purchases','add_purchases','quotes','add_providers'
	];

	consignment_permissions:string[] = [
		'add_consignment_received','view_consignment_received',
		'add_consignment_delivered','view_consignment_delivered'
	];

	order_permissions:string[] = [
		'list_orders','advanced_order_search','fullfill_orders','cancel_closed_orders','show_tables',
		'order_delivery','global_order_delivery','view_commandas'
	];

	punto_venta_permissions:string[] = [
		'add_credit_limit', 'pos','cancel_ordered_item','open_cashier_box_anytime',
		'print_pre_receipt','global_pos','pv_returns','add_payments','discounts',
		'add_credit_sales','return_money', 'delete_draft_items'
	];

	gastos_permissions:string[] = ['pay_bills','add_bills','approve_bill_payments'];
	comisiones_permissions:string[] = ['view_commissions','pay_commissions','approve_commissions'];

	precios_permissions:string[] =[
		'store_prices','global_prices','price_types', 'add_offers', 'add_item_points',
		'change_client_prices'
	];

	inventarios_permission:string[] = [
		'add_items','view_stock','add_stock','global_add_stock', 'stocktake', 'add_consumptions',
		'add_merma'
	];

	administration_checked:boolean = false;

	ngOnInit()
	{
		this.subs.sink = this.route.paramMap.subscribe( params =>
		{
			this.is_loading = true;
			let defaultUser:Partial<User> = {
				name: '',
				store_id: undefined,
				type:'USER',
				credit_days: 0,
				credit_limit: 0,
				price_type_id: undefined,
			};

			this.subs.sink = forkJoin({
				user: params.has('id') ? this.rest.user.get(params.get('id')) : of(defaultUser),
				stores: this.rest.store.search({limit:99999,sort_order:['name_ASC']}),
				user_permission: params.has('id') ? this.rest.user_permission.get( params.get('id') ) : of(GetEmpty.user_permission()),
				roles: this.rest_role.search({limit:99999,sort_order:['name_ASC']}),
				user_storages: params.has('id') ? this.rest.user_storage_info.search({eq:{user_id: parseInt( params.get('id')!)}, limit:99999}) : of({total:0,data:[]}),
				all_storages: this.rest.storage.search({limit:99999,sort_order:['name_ASC']})
			})
			.subscribe((response)=>
			{
				this.role_list = response.roles.data;
				this.is_loading = false;
				this.user = response.user;
				this.store_list = response.stores.data;
				this.user_permission = response.user_permission;
				this.user_storage_list = response.user_storages.data;
				this.all_storage_list = response.all_storages.data;
			});
		});
	}

	save()
	{
		this.is_loading = true;

		if( this.user.id	)
		{
			this.user.username = this.user.email;
			this.subs.sink	= forkJoin({
				user: this.rest.user.update( this.user ),
				permissions: this.rest.current_permission.add_user ? this.rest.user_permission.update( this.user_permission ) : of(this.rest.current_permission)
			})
			.subscribe((response)=>{
				if( this.rest.current_user.id == response.user.id )
				{
					this.rest.user_permission.search({ eq:{ user_id: response.user.id }, limit:1 }).subscribe((permission_response)=>{
						let permission = permission_response.data[0];
						if( permission )
						{
							this.rest.current_permission = permission;
							localStorage.setItem(USER_PERMISSION_KEY, JSON.stringify(permission));
						}
					},(error)=>this.showError(error));
				}

				this.is_loading = false;
				//this.router.navigate(['/list-user']);
				this.location.back();
				this.showSuccess('El usuario se actualizó exitosamente');
			},(error)=>this.showError(error));

		}
		else
		{
			//this.user.name;// = this.user.username;
			this.user.username = this.user.email;
			this.subs.sink	= this.rest.user.create( this.user ).subscribe((user)=>{
				this.user = user;
				this.user_permission.user_id = user.id;
				this.rest.user_permission.update(this.user_permission).subscribe((response)=>
				{
					if(response.user_id == this.rest.current_user.id )
					{
						this.rest.user_permission.search({ eq:{ user_id: user.id }, limit:1 }).subscribe((permission_response)=>{
							let permission = permission_response.data[0];
							if( permission )
							{
								this.rest.current_permission = permission;
								localStorage.setItem(USER_PERMISSION_KEY, JSON.stringify(permission));
							}
						},(error)=>this.showError(error));
					}
				},(error)=>{
					this.showError(error);
				});
				this.showSuccess('El usuario se guardó exitosamente');
				this.is_loading = false;
				this.location.back();
				//this.router.navigate(['/list-user']);
			},(error)=>this.showError(error));
		}
	}

	toggleValue(key:string)
	{
		this.user_permission[key] = this.user_permission[key]?0:1;
	}

	//all:boolean


	toggleAll(all:string,permission:string[])
	{
		let result = permission.reduce((acc,curr)=>acc && this.user_permission[curr],true);
		for(let i of permission)
		{
			this.user_permission[i] = result?0:1;
		}

		if( permission === this.administracion_permissions )
		{
			this.administration_checked = result;
		}
	}




	togglePasswordType(evt:Event)
	{
		let check = evt.target as HTMLInputElement;
		this.password_type = check.checked ? 'text' : 'password';
	}

	areAllSelected(permissions:string[]):boolean
	{
		return permissions.reduce((acc,curr)=>acc && this.user_permission[curr],true) as boolean;
	}

	addStorage()
	{
		if( !this.new_user_storage.storage_id )
		{
			this.showError('Seleccione un almacén');
			return;
		}

		this.is_loading = true;
		this.new_user_storage.user_id = this.user.id!;
		this.subs.sink = this.rest.user_storage.create( this.new_user_storage ).subscribe((response)=>
		{
			this.is_loading = false;
			this.showSuccess('Almacén asignado exitosamente');
			this.new_user_storage.storage_id = 0;
			this.fetchUserStorages();
		},(error)=>this.showError(error));
	}

	deleteStorage(assignment:User_Storage)
	{
		this.is_loading = true;
		this.subs.sink = this.rest.user_storage.delete( assignment ).subscribe((response)=>
		{
			this.is_loading = false;
			this.showSuccess('Asignación eliminada');
			this.fetchUserStorages();
		},(error)=>this.showError(error));
	}

	fetchUserStorages()
	{
		this.subs.sink = this.rest.user_storage_info.search({eq:{user_id: this.user.id!}, limit:99999}).subscribe((response)=>
		{
			this.user_storage_list = response.data;
		});
	}
}
